(function () {
  angular
    .module('specsguardApp')
    .controller('widgetProjectTeam', widgetProjectTeam);

  widgetProjectTeam.$inject = ['Labels', 'Constants', 'User', '$scope', 'errorMessageService',
    'Project', '$mdDialog', 'Auth', 'sg2ModalService'];

  function widgetProjectTeam (Labels, Constants, User, $scope, errorMessageService,
    ProjectAPI, $mdDialog, Auth, sg2ModalService) {

    const vm = this;
    vm.LABELS = Labels;
    vm.userRoles = Constants.getList('USER_ROLES');
    vm.userStatus = Constants.getList('USER_STATUS');
    vm.user = Auth.getCurrentUser();

    vm.$onInit = function (updatedProject) {
      vm.project = $scope.project;
      vm.project.users = updatedProject || $scope.project.users;
    };

    /**
     * removeUser()
     *
     * Function used to remove an user from the project
     *
     */
    vm.removeUser = (user, evt) => {

      // We're not allowed to remove all the users from the team
      if (activeUsersCount() <= 1) {
        const dialogConfig = {
          disableClose: true,
          content: vm.LABELS.getLabel('teamminimum'),
          title: vm.LABELS.getLabel('deletingnotpossible'),
          action: vm.LABELS.getLabel('cancel'),
          type: 'warn'
        };

        // As this is just an alert, I don't need to subscribe to the "cancel" event
        vm.openConfirmModal(dialogConfig);

      } else {
        // When the user is active
        if (user.active) {
          // Doublecheck to make sure we're editing an existing project user
          // If found we should update the scope user
          vm.project.users.forEach((projectUser) => {
            if (projectUser._id === user._id) {
              return disableUser(projectUser);
            }
          });

          return userApiCall(vm.project.users, vm.LABELS.getLabel('projectuserdeactivate'));
        }

      }
    };

    vm.openConfirmModal = (dialogConfig) => {
      return sg2ModalService.confirm(dialogConfig); // to catch the events
    };

    vm.checkUser = (id) => {
      return existingUser(vm.project.users, id);
    };

    /**
     * Modal used for adding a new user
     */
    vm.addUsersModal = (ev) => {
      $mdDialog.show({
        scope: $scope.$new(),
        controller: 'WidgetProjectTeamAddUser',
        controllerAs: 'WidgetProjectTeamAddUserCtrl',
        bindToController: true,
        preserveScope: true,
        clickOutsideToClose: true,
        targetEvent: ev,
        templateUrl: 'app-legacy/project/overview/widgets/team/add-user/widget-project-team-add-user.tmpl.html',
        locals: {
          project: vm.project,
          tenantUsers: [User.query({currentTenant: true}).$promise]
        },
      }).then((updatedProject) => {
        vm.$onInit(updatedProject);
      }).catch(() => {});
    };

    /**
     * Disable and remove an active user from the project.
     *
     * @param {Object} users object containing all the users who are part of the project
     */
    const disableUser = (user) => {
      user.active = false;
      return user;
    };

    /**
     * Compare the selected ID with the project users object.
     *
     * @param {Object} users object containing all the users who are part of the project
     * @param {String} id contains the users id
     */
    const existingUser = (users = vm.project.users, id) => users.some((user) => user.userId._id === id);

    /**
     * Count active users
     *
     * @param {Object} users object containing all the users
     */
    const activeUsersCount = () => {
      let count = 0;
      for (const member of vm.project.users) {
        if (member.active) {
          count++;
        }
      }

      return count;
    };


    /**
     * Api call function to update the project
     *
     * @param {Object} users object containing all the users who are part of the project
     */
    const userApiCall = (users, successMsg) => {
      const data = {
        project: {
          users,
        },
        _id: $scope.project._id,
        versionId: $scope.project.versionId,
      };

      return ProjectAPI.editProject(data).$promise.then((updatedProject) => {
        vm.project = updatedProject;
        errorMessageService.showSuccess(successMsg);
        vm.$onInit();
      });
    };

  }
})();
